// v2/hooks/useAdminDebt.js — yonetim borc yaslandirma + kisitlama
import { useCallback, useEffect, useRef, useState } from 'react';
import { apiGet, apiPost, qs } from '../utils/api';

export default function useAdminDebt(params) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const abortRef = useRef(null);
  const sorgu = qs(params);
  const [tetik, setTetik] = useState(0);

  const yenile = useCallback(() => setTetik((n) => n + 1), []);

  useEffect(() => {
    if (abortRef.current) abortRef.current.abort();
    const ctrl = new AbortController();
    abortRef.current = ctrl;
    setLoading(true);
    setError(null);
    apiGet(`/v2/admin/debt/${sorgu}`, { signal: ctrl.signal })
      .then((veri) => {
        if (ctrl.signal.aborted) return;
        if (!veri || !veri.success) throw new Error((veri && veri.message) || 'Veri alınamadı');
        setData({
          ...veri,
          items: Array.isArray(veri.items) ? veri.items : [],
          filtered: veri.filtered || {},
          summary: veri.summary || {},
          risk_counts: veri.risk_counts || {},
        });
      })
      .catch((e) => {
        if (ctrl.signal.aborted || (e && e.name === 'AbortError')) return;
        setError((e && e.message) || 'Veri alınamadı');
      })
      .finally(() => { if (!ctrl.signal.aborted) setLoading(false); });
    return () => ctrl.abort();
  }, [sorgu, tetik]);

  return { data, loading, error, yenile };
}

/** 12 aylik trend (sekme acilinca) */
export function useDebtTrend(etkin) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!etkin || data) return undefined;
    const ctrl = new AbortController();
    setLoading(true);
    apiGet('/v2/admin/debt/trend/', { signal: ctrl.signal })
      .then((v) => { if (!ctrl.signal.aborted && v && v.success) setData(v.trend || []); })
      .catch(() => {})
      .finally(() => { if (!ctrl.signal.aborted) setLoading(false); });
    return () => ctrl.abort();
  }, [etkin, data]);

  return { trend: data, loading };
}

export const adminDebtApi = {
  musteri: (kod) => apiGet(`/v2/admin/debt/customer/${qs({ code: kod })}`),
  senkron: () => apiPost('/v2/admin/debt/sync/', {}),
  kisitlamaKaydet: (govde) => apiPost('/v2/admin/restrictions/save/', govde),
  kisitlamaSil: (kod) => apiPost('/v2/admin/restrictions/delete/',
    { musteri_kodu: kod, confirm: true }),
};
